export const getTitle = () => {
  const { hostname } = document.location;

  switch (hostname) {
    case "localhost":
      return "[로컬] 관리자 페이지";
    case "dev.admin.onggoing.com":
      return "[개발] 관리자 페이지";
    case "qa.admin.onggoing.com":
      return "[QA] 관리자 페이지";
    default:
      return "관리자 페이지";
  }
};
